function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M23.681,66.137H2c-1.104,0-2,0.896-2,2v21.682c0,1.104,0.896,2,2,2h21.681c1.104,0,2-0.896,2-2V68.137 C25.681,67.032,24.785,66.137,23.681,66.137z"
}), React.createElement("path", {
  d: "M58.41,66.137H36.728c-1.104,0-2,0.896-2,2v21.682c0,1.104,0.896,2,2,2h21.681c1.104,0,2-0.896,2-2V68.137 C60.41,67.032,59.514,66.137,58.41,66.137z"
}), React.createElement("path", {
  d: "M93.824,66.137H72.143c-1.104,0-2,0.896-2,2v21.682c0,1.104,0.896,2,2,2h21.682c1.104,0,2-0.896,2-2V68.137 C95.824,67.032,94.93,66.137,93.824,66.137z"
}), React.createElement("path", {
  d: "M37.072,29.687h21.68c1.104,0,2-0.896,2-2V6.006c0-1.104-0.896-2-2-2h-21.68c-1.104,0-2,0.896-2,2v21.681 C35.072,28.792,35.968,29.687,37.072,29.687z"
}), React.createElement("path", {
  d: "M9.513,59.209h4.103c1.104,0,2-0.896,2-2v-8.441h28.245v8.465c0,1.104,0.896,2,2,2h4.103c1.104,0,2-0.896,2-2v-8.465 h28.245v8.449c0,1.104,0.896,2,2,2h4.104c1.104,0,2-0.896,2-2V42.663c0-1.104-0.896-2-2-2h-34.35v-2.775c0-1.104-0.896-2-2-2 H45.86c-1.104,0-2,0.896-2,2v2.775H9.513c-1.104,0-2,0.896-2,2v14.545C7.513,58.312,8.409,59.209,9.513,59.209z"
})));

var SvgStructure = function SvgStructure(props) {
  return React.createElement("svg", _extends({
    id: "structure-icon",
    x: "0px",
    y: "0px",
    width: "95.824px",
    fill: "white",
    height: "95.824px",
    viewBox: "0 0 95.824 95.824",
    style: {
      enableBackground: "new 0 0 95.824 95.824"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/structure.54e5d3de.svg";
export { SvgStructure as ReactComponent };